/**
 * @param {google.maps.LatLngBounds} bounds
 * @param {google.maps.GeometryLibrary} geometryLibrary
 * @return {google.maps.MapRestriction | null}
 */
export function convertBoundsToRestriction(bounds, geometryLibrary) {
  if (bounds.isEmpty()) {
    return null;
  }

  const sw = bounds.getSouthWest();
  const ne = bounds.getNorthEast();
  const spherical = geometryLibrary.spherical;
  const bufferDistanceMeters = spherical.computeDistanceBetween(ne, sw);
  const bufferedBounds = new google.maps.LatLngBounds(
    spherical.computeOffset(sw, bufferDistanceMeters, 225),
    spherical.computeOffset(ne, bufferDistanceMeters, 45)
  );

  // Don't restrict when longitudes wrap, it implies global scale
  if (bufferedBounds.getSouthWest().lng() > bufferedBounds.getNorthEast().lng()) {
    return null;
  }

  // Don't restrict when buffered bounds don't contain the original, it implies global scale
  if (!bufferedBounds.contains(bounds.getSouthWest()) || !bufferedBounds.contains(bounds.getNorthEast())) {
    return null;
  }

  return {
    latLngBounds: bufferedBounds,
    strictBounds: false,
  };
}
